"use strict";

exports.__esModule = true;
var _resolveStyleCssValue = require("./resolve-style-css-value");
Object.keys(_resolveStyleCssValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _resolveStyleCssValue[key]) return;
  exports[key] = _resolveStyleCssValue[key];
});
//# sourceMappingURL=index.js.map